/* eslint-disable */
import React from 'react'
import { Checkbox as AntdCheckbox } from 'antd'
import styled from 'styled-components'

const StyledCheckbox = styled(AntdCheckbox)`
  .ant-checkbox + span {
    padding-left: 12px;
  }
`
const LabelWrapper = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #202020;
`

const Checkbox = ({ onChange, label, checked, labelStyle, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} checked={checked}>
      <LabelWrapper style={labelStyle}>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default Checkbox
